import { Component, OnInit } from '@angular/core';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-monitoring',
    templateUrl: './monitoring.component.html',
    styleUrls: ['./monitoring.component.scss'],
    standalone: false
})
export class MonitoringComponent implements OnInit {

  constructor(private router: Router, public sideNavBarVisibilityService: SideNavBarVisibilityService, public themeService: ThemeService) { }

  ngOnInit() {
  }

}
